import { TUpdateUserPasswordParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const updateUserPassword = async (params: TUpdateUserPasswordParams) => {
  const { nextPassword, actualPassword, userRoles } = params;

  const request = (() => {
    if (userRoles.includes('ADMIN')) {
      return m8API.admin.changeAdminPassword({
        newPassword: nextPassword,
        oldPassword: actualPassword,
      });
    }

    return m8API.user.changeClientPassword({
      newPassword: nextPassword,
      oldPassword: actualPassword,
    });
  })();

  await request;
};
